export default __webpack_public_path__ + "static/media/images.b03d0306.svg";